import { useAuth0 } from '@auth0/auth0-react';

export default () => {
  const { logout } = useAuth0();

  logout({ returnTo: window.location.origin });

  return null;
};
